/**
 * <ln-tabs>
 *   <div role="tablist"> <button role="tab" aria-controls="panel-id" aria-selected="true"> … </div>
 *   <div role="tabpanel" id="panel-id"> … </div>
 * </ln-tabs>
 *
 * Accessible tabs with arrow-key navigation. Videos in hidden panels are paused, and the
 * active panel's autoplay videos are resumed, so only one tab plays at a time.
 */
if (!customElements.get('ln-tabs')) {
  customElements.define(
    'ln-tabs',
    class LnTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      onKeydown(event, index) {
        const keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        const next = (index + keys[event.key] + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (!panel) return;
          panel.hidden = !active;
          panel.querySelectorAll('video').forEach((video) => {
            if (!active) video.pause();
            else if (video.autoplay) video.play().catch(() => {});
          });
        });
      }
    }
  );
}
